import React, { Fragment, useState } from 'react';
import { Row, Col, Input, Button } from 'reactstrap';
import { Search } from 'react-feather';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters, resetFilters } from 'Services/Features/User/userSlice';
import { getUser, exportUsers } from 'Services/Features/User/Utils/userUtils';
import Select from 'react-select';

const FindUser = () => {
    const dispatch = useDispatch()
    const filters = useSelector(state => state.user.filters)
    const [selectedSortValue, setSelectedSortValue] = useState(null)

    const options = [
        { value: 'name', label: 'A-Z' },
        { value: '-name', label: 'Z-A' },
        { value: '-id', label: 'Terbaru' },
        { value: 'id', label: 'Terlama' },
    ];

    const handleClickExportUser = (e) => {
        e.preventDefault()
        dispatch(exportUsers(filters));
    }

    const handleSelectChangeSort = (selectedOption) => {
        setSelectedSortValue(selectedOption);
        const newFilters = {
            ...filters,
            'sort': selectedOption === null ? '' : selectedOption.value,
        }
        dispatch(setFilters(newFilters));
        dispatch(getUser(newFilters));
    }

    const handleClickSearch = (e) => {
        e.preventDefault()
        const newFilters = {
            ...filters,
            'page': 1,
        };
        dispatch(setFilters(newFilters));
        dispatch(getUser(newFilters));
    }

    const handleResetFilter = (e) => {
        e.preventDefault()
        dispatch(resetFilters());
        dispatch(getUser());
        setSelectedSortValue(null);
    }

    return (
        <Fragment>
            <Col xl="12">
                <div className="job-filter">
                    <div className="faq-form">
                        <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="12" lg="12" xl="12">
                            <Row className="w-100">
                                <Col className="d-flex justify-content-between align-items-center mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <div className="position-relative w-100">
                                        <Input className="form-control" type="text" placeholder="Cari pengguna.."
                                            value={filters['filter[name]']}
                                            onKeyUp={(e) => e.key === 'Enter' ? handleClickSearch(e) : null}
                                            onChange={(e) => {
                                                dispatch(setFilters({
                                                    ...filters,
                                                    'filter[name]': e.target.value
                                                }));
                                            }}
                                        />
                                        <Search className="search-icon position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }} />
                                    </div>
                                </Col>
                                <Col className="mb-2" xs="12" sm="12" md="4" lg="4" xl="2" style={{ whiteSpace: 'nowrap' }}>
                                    <Select
                                        options={options}
                                        className="js-example-basic-single"
                                        isMulti={false}
                                        isClearable={true}
                                        placeholder="Sort by.."
                                        onChange={handleSelectChangeSort}
                                        value={selectedSortValue}
                                    />
                                </Col>
                                <Col className="d-flex justify-content-end align-items-center px-0" xs="12" sm="12" md="4" lg="4" xl="8" style={{ whiteSpace: 'nowrap' }}>
                                    <Button color="warning me-2" onClick={handleResetFilter}>Reset</Button>
                                    <Button color="primary me-2" onClick={handleClickSearch}>Filter</Button>
                                    <Button color="success" onClick={handleClickExportUser}> <i className="fa fa-download"></i> Ekspor</Button>
                                </Col>
                            </Row>
                        </Col>
                    </div>
                </div>
            </Col>
        </Fragment>
    );
};

export default FindUser;